import { create } from 'zustand'

export const ebookStore = create((set, get) => ({
  currentChapter: 0,
  currentSection: 0,
  bookmarks: [],
  readingProgress: {},
  notes: {},
  audioSettings: {
    volume: 0.7,
    playbackRate: 1
  },

  setCurrentChapter: (chapter) => set({ currentChapter: chapter }),
  
  setCurrentSection: (section) => set({ currentSection: section }),

  addBookmark: (chapterId, sectionId, note = '') => {
    const bookmarks = get().bookmarks
    const newBookmark = {
      id: Date.now(),
      chapterId,
      sectionId,
      note,
      createdAt: new Date().toISOString()
    }
    set({ bookmarks: [...bookmarks, newBookmark] })
  },

  removeBookmark: (bookmarkId) => {
    const bookmarks = get().bookmarks.filter(b => b.id !== bookmarkId)
    set({ bookmarks })
  },

  updateReadingProgress: (chapterId, progress) => {
    const readingProgress = get().readingProgress
    set({ 
      readingProgress: { 
        ...readingProgress, 
        [chapterId]: Math.max(readingProgress[chapterId] || 0, progress) 
      } 
    })
  },

  addNote: (chapterId, sectionId, content) => {
    const notes = get().notes
    const key = `${chapterId}-${sectionId}`
    set({ notes: { ...notes, [key]: content } })
  },

  getNote: (chapterId, sectionId) => {
    const notes = get().notes
    const key = `${chapterId}-${sectionId}`
    return notes[key] || ''
  },

  setAudioSettings: (settings) => set({ 
    audioSettings: { ...get().audioSettings, ...settings } 
  }),

  getTotalProgress: () => {
    const progress = get().readingProgress
    const chapters = Object.keys(progress)
    if (chapters.length === 0) return 0
    const total = chapters.reduce((sum, key) => sum + progress[key], 0)
    return Math.round(total / 8)
  }
}))
